// extracted by mini-css-extract-plugin
export default {"printarea":"DefaultForms_printarea__SsRww","rowItem":"DefaultForms_rowItem__dyoWC"};